"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const IcDataCollection = (props) => ((0, jsx_runtime_1.jsx)("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { d: "M3 15L8.61071 9.0151L11.3893 11.9849L17 6.00002", stroke: "black", strokeWidth: 1.2 }) })));
exports.default = IcDataCollection;
